<script>
import FormGuideMeetingHeaderDesktop from './FormGuideMeetingHeaderDesktop.vue';
import FormGuideMeetingHeaderMobile from './FormGuideMeetingHeaderMobile.vue';
import moment from 'moment';
export default {
  name: 'FormGuideMeetingHeader',
  components: {
    FormGuideMeetingHeaderDesktop,
    FormGuideMeetingHeaderMobile,
  },
  props: {
    slug: {
      type: String,
      required: true,
    },
    activeEventNumber: {
      type: String,
      required: true,
    },
    activeView: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      viewportWidth: window.innerWidth,
    };
  },
  computed: {
    isMobile() {
      return this.viewportWidth < 768;
    },
  },
  mounted() {
    const { setWindowWidth, slug, fecthMeetingData } = this;
    // add listener to handle page resize
    window.addEventListener('resize', setWindowWidth);
    setWindowWidth();
    // get start and end dates for meetings dropdown
    const { startDate, endDate } = fecthMeetingData();
    // fetch meeting by slug and meetings by date
    this.$store.dispatch('FormGuideMeetingHeader/fetchMeetingData', { slug, startDate, endDate });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setWindowWidth);
  },
  methods: {
    setWindowWidth() {
      this.viewportWidth = window.innerWidth;
    },
    fecthMeetingData() {
      const today = Date.now();
      const startDate = moment
        .utc(today)
        .local()
        .format('YYYY-MM-DD');
      const endDate = moment
        .utc(today)
        .add(3, 'days')
        .local()
        .format('YYYY-MM-DD');

      return { startDate, endDate };
    },
  },
};
</script>

<template>
  <div class="fg-meeting-header">
    <FormGuideMeetingHeaderDesktop
      v-if="!isMobile"
      :active-event-number="activeEventNumber"
      :active-view="activeView"
    />
    <FormGuideMeetingHeaderMobile
      v-else
      :slug="slug"
      :active-event-number="activeEventNumber"
      :active-view="activeView"
    />
  </div>
</template>
